import { Required } from '@hvlng/framework-bff/core';
import { HvlDateConverter } from '@hvlng/framework-bff/util';
import { HvlBaseModel } from '@hvlng/framework-bff/core';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('KovanHrBasicTimeConstrainedBaseModel')
export class BasicTimeConstrainedBaseModel extends HvlBaseModel {
    @Required()
    @JsonProperty('beginDate', HvlDateConverter, true)
    beginDate: Date = null;

    @Required()
    @JsonProperty('endDate', HvlDateConverter, true)
    endDate: Date = null;
}
